import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_CLUES_SUCCESS:
    case constants.GET_CLUES_BY_SPARK_ID_SUCCESS:
      return Object.assign({}, state, {
        clues: action.clues.data || [],
        isRefreshRequired: false,
      });
    case constants.GET_CLUES_BY_PROVIDER_ID_SUCCESS:
    case constants.UPLOAD_CLUE_SUCCESS:
      return Object.assign({}, state, {
        clues: action.clues,
        isRefreshRequired: false,
      });
    case constants.POST_CLUE_SUCCESS:
      return Object.assign({}, state, {
        newId: action.newId,
        isRefreshRequired: true,
      });
    case constants.GET_CLUES_ERROR:
    case constants.GET_CLUES_BY_PROVIDER_ID_ERROR:
    case constants.GET_CLUES_BY_SPARK_ID_ERROR:
    case constants.POST_CLUE_ERROR:
    case constants.PATCH_CLUE_ERROR:
    case constants.UPLOAD_CLUE_ERROR:
      return {
        error: action.error,
      };
    case constants.PATCH_CLUE_SUCCESS:
    case constants.UPLOAD_CLUE:
      return Object.assign({}, state, {
        isRefreshRequired: true,
      });
    default:
      return state;
  }
}
